export default "__VITE_ASSET__DdbbULi9__"